const STORAGE_KEY = 'player_device_key';

export function ensureDeviceKey(): string {
  if (typeof window === 'undefined') {
    return 'dev_static_key';
  }
  const existing = window.localStorage.getItem(STORAGE_KEY);
  if (existing) {
    return existing;
  }
  const generated = `dev_${crypto.randomUUID()}`;
  window.localStorage.setItem(STORAGE_KEY, generated);
  return generated;
}



